import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';


import {
  startGetUserTemplates,
  setCalculatingCountry,
  setCalculating,
  startSavingCalculation,
  startLoadingCalculations,
  startDeletingCalculation,
  startLoadingCalculatingTopicData
} from '../../actions';


import {
  Card,
  CountryFlagRounded,
  CalculationCategoryCard,
  DisplayPercent,
  PercentBar,
  Modal,
  Loading
} from '../../components';

import ModalAllCategories from './modal-all-categories';

import { previewCategories, compareCalcTemplate } from '../../tools/templateTools';


import {getDefaultCountryData} from '../../services/countryData';

import {fmtNumOrd} from '../../tools/tools';


import './calculation.css';


let preLoaderTriggered=false,
  apiDataLoaded=false;

const Calculation=({
  calculating,
  calculatingCountry,
  calculationStatus,
  calculationList,
  userTemplates,

  startSavingCalculation,
  startLoadingCalculations,
  startDeletingCalculation,
  setCalculating,
  setCalculatingCountry,
  startGetUserTemplates,
  startLoadingCalculatingTopicData,

  match:{params:{id}},
  history

})=>{

  // const [isProcessing,setIsProcessing]=useState(''); // '' | 'loading'
  const [errorIds,setErrorIds]=useState([]);
  const [saveTried,setSaveTried]=useState(false);
  const [isOpenModalAlert,setIsOpenModalAlert]=useState(false);
  const [isOpenSeeAllCats,setIsOpenSeeAllCats]=useState(false);
  const [isOpenModalTemplateAlteration,setIsOpenModalTemplateAlteration]=useState(false);
  const [isOpenModalMsg,setIsOpenModalMsg]=useState(false);
  const [editedTemp,setEditedTemp]=useState(false);
  const [changedTemplateRelatedData,setChangedTemplateRelatedData]=useState(false);


  // TODO - review
  const [defaultApiData,setDefaultApiData]=useState([]);
  const [defaultApiDataStatus,setDefaultApiDataStatus]=useState(''); //  is 'loading' ?



  useEffect(()=>{
    if(!defaultApiData.length) {
      // getting default api data
      if(calculatingCountry.length) {
        getDefaultCountryData({country:calculatingCountry[0], setStatus:setDefaultApiDataStatus})
        .then(ret=>{
          // console.log('API DATA!',ret);
          setDefaultApiData(ret.arrayData);
        })
        .catch(err=>console.log('ERROR API DATA',err));
      }


    }
  },[calculating]);




  if(id && (!calculating || !calculating.templateId)) {
    const calculating=calculationList.find(elem=>elem._id===id);
    if(calculating) {
      setCalculating(calculating);
      setCalculatingCountry([calculating.country]);

      // getTemplateTopicsData(calculating)
      // .then(ret=>{
      //   console.log('topics infs!',ret);
      //   calculating.categories.forEach(cat=>{
      //     cat.topics.forEach(elem=>{
      //       const {topic}=elem;
      //       const dataTopic=ret.find(elem=>elem.topic===topic);
      //       if(dataTopic && dataTopic.value) {
      //         elem.information=dataTopic.value;
      //       }
      //     });
      //   });
      //   setCalculating(calculating);
      //   console.log('new calculating with INFORMATION',calculating);
      // })
      // .catch(err=>console.log('topics infs ERROR',err))



    } else {
      if(!preLoaderTriggered) {
        preLoaderTriggered=true;
        startGetUserTemplates();
        startLoadingCalculations();
      }
    }
  }


  const calcTemplate = userTemplates.find(elem=>elem._id===calculating.templateId) || {};
  const templateName=calcTemplate.template;
  const {fit}=calculating;

  

  useEffect(()=>{
    return ()=>{
      setCalculating();
      apiDataLoaded=false;
    }
  },[]);
  
  
  useEffect(()=>{
    if(changedTemplateRelatedData) {
      setIsOpenModalTemplateAlteration(true);
    }

  },[changedTemplateRelatedData]);
  
  // following errors
  useEffect(()=>{

    if(!apiDataLoaded && calculating && (calculating.country || calculatingCountry[0])) {
      if(!calculating.country) {
        calculating.country=calculatingCountry[0];
      }
      startLoadingCalculatingTopicData(calculating);
      apiDataLoaded=true;
    }

    // comparing the "calculating" against its base template
    const diffs=compareCalcTemplate(calculating,calcTemplate);
    if(diffs.length) {
      setEditedTemp(<span>(edited)</span>);
    } else {
      setEditedTemp(false);
    }
    // console.log('useEffect[calculating, calculatingCountry]',[calculating,calculatingCountry]);

    if(saveTried) {
      setErrorIds(calculating.validate2Save());
    }
    return ()=>{
      preLoaderTriggered=false;
    }
  },[calculating,calculatingCountry]);


  // Not enough data?
  if((!calculatingCountry || !calculatingCountry.length) || (!calculating || !calculating.templateId)) {
    // trying to get data...
    if(calculationStatus === 'loading') {
      return (
        <div className="background-default1 page-content calculation-loading-data">
          <Loading status={calculationStatus} />
          <h1>Wait, loading data...</h1>
        </div>
      )
    }

    return (
      <div className="background-default1 page-content calculating-page-error-msg">
        <h1 className="font-color-error1">Calculating data was not found!</h1>
        <h3>Go back to Dashboard and select a calculation or click the "New Calculation" button.</h3>
        <Link className="btn btn-default1" to="/dashboard">Dashboard</Link>
      </div>
    )
  }
  
  const closeModalAlert=()=>{
    setIsOpenModalAlert(false);
  }
  const closeModalAlertMsg=()=>{
    setIsOpenModalMsg(false);
  }
  const closeModalTemplateAlteration=()=>{
    setIsOpenModalTemplateAlteration(false);
  
  }
  const openCloseModalSeeAllCats=(fnc)=>{
    return ()=>{
      setIsOpenSeeAllCats(fnc);
    }
  }


  // used to detect the sync between "calculating" and its base template
  const onChangeData=(fieldName)=>{
    const fields=['relevance']
    if(fields.includes(fieldName)) {
      setChangedTemplateRelatedData(true);
    }
  }

  const onDeleteCalculation=()=>{
    startDeletingCalculation(id)
    .then(()=>{
      history.push('/dashboard');
    })
  }

  const onSaveCalculation=()=>{
    setSaveTried(true);
    calculating.country=calculatingCountry[0];
    const errors=calculating.validate2Save();
    setErrorIds(errors);
    if(errors.length) {
      setIsOpenModalAlert(true);
      return false;
    }
    // console.log('##### SAVING CALC #####');
    // console.log(calculating.final());
    startSavingCalculation(calculating)
    .then(()=>{
      // alert
      setIsOpenModalMsg(true);
    })
  }

  // Alert Modal
  const alertModal=(
    <Modal isOpen={isOpenModalAlert} onClose={closeModalAlert} className="modal-content-default template-alert-modal">
      <div className="font-color2">
        <h3 className="font-color-error1">Errors were found!</h3>
        <p>Please check all the topics highlighted in <span className="font-color-error1">red</span>.</p>
        <p className="template-alert-modal-error-hint">
          Check all topic's score fields. It *MUST* be between 1 and 10.
        </p>
        <div className="modal-controls">
          <button onClick={closeModalAlert} className="btn btn-default1" type="button">Ok</button>
        </div>
      </div>
    </Modal>
  )
  
  
  // Alert Modal Msg
  const alertModalMsg=(
    <Modal isOpen={isOpenModalMsg} onClose={closeModalAlertMsg} className="modal-content-default template-alert-modal calc-alert-modal-msg">
      <div className="font-color2">
        <h3 className="font-color-success1">Saved successfully!</h3>
        <div className="modal-controls">
          <button onClick={closeModalAlertMsg} className="btn btn-default1" type="button">Ok</button>
        </div>
      </div>
    </Modal>
  )

  // Alert Modal
  const alertTemplateAlteration=(
    <Modal isOpen={isOpenModalTemplateAlteration} onClose={closeModalTemplateAlteration} className="modal-content-default template-alert-modal">
      <div className="font-color2">
        <p className="notice1">
          <span className="font-color-error1">Alert:</span> the change in this selection criteria won't be automatically modified on other countries you are analyzing. If you want to change it, do not forget to alter other calculators as well.
        </p>
        <div className="modal-controls">
          <button onClick={closeModalTemplateAlteration} className="btn btn-default1" type="button">Ok</button>
        </div>
      </div>
    </Modal>
  )



  // template
  const { categories } = calculating;
  const categoriesHtml = categories.map((cat, index) => <CalculationCategoryCard onChangeData={onChangeData} errorIds={errorIds} index={index} key={'calc_cat_' + index} category={cat} />)


  // Percent Bars
  let seeAllCatsBnt=false;
  let displayableCats=categories.filter(elem=>!!elem.fit);
  let percentBars=<p className="notice1">Fill the scores fields to create fit data.</p>;
  if(displayableCats.length) {

    const previewCats=previewCategories(displayableCats);
    percentBars=previewCats.map((elem,index)=>{
      const {category,fit}=elem;
      return <PercentBar key={'percent_bar_'+index} name={category} percent={fit} />
    });
  }

  // See all categories btn
  if(displayableCats.length > 3) {
    seeAllCatsBnt=<button onClick={openCloseModalSeeAllCats(true)} className="btn btn-default1 btn-xs" type="button">See all</button>
  }

  // Delete btn
  let deleteBtn=false;
  if(id) {
    deleteBtn=<button onClick={onDeleteCalculation} disabled={(!!calculationStatus)} type="button" className="btn btn-default-cancel btn-xs">Delete Calculation</button>
  }



  return (
    <div className="background-default1 page-content">
      <ModalAllCategories isOpen={isOpenSeeAllCats} onCancel={openCloseModalSeeAllCats(false)} categories={displayableCats} />
      <h2 className="page-title">Calculation / <span className="notice1">Country</span></h2>
      <div className="calculation-header flex-between">
        <Loading status={calculationStatus} />
        <Card className="calculation-header-country1 font-color2">
          <Loading status={defaultApiDataStatus} />
          <div className="calculation-header-country1__left">
            <CountryFlagRounded countryData={calculatingCountry} />
            <h2 className="font-color2 country-name">{calculatingCountry[0]}</h2>
            <h3>Region: <span>{defaultApiData[7]}</span></h3>
            <h3>Language: <span>{defaultApiData[6]}</span></h3>
            <h3>Currency: <span>{defaultApiData[5]}</span></h3>
          </div>
          <div>
            <h3 className="calc-header-apidata-items-top">{defaultApiData[0]} <span>Population</span></h3>
            <h3 className="calc-header-easeofdb calc-header-apidata-items-top">{fmtNumOrd(defaultApiData[1])} <span>Ease of doing business</span></h3>
            <h3 className="calc-header-apidata-items-bottom">{defaultApiData[2]} <span>GDP US$</span></h3>
            <h3 className="calc-header-apidata-items-bottom">{defaultApiData[3]} <span>GDP Per Capita US$</span></h3>
          </div>
        </Card>
        <Card className="calculation-header-country2">
          <div>
            <h2 className="font-color2">Country Fit</h2>
            <DisplayPercent percent={fit} />
          </div>
          <div>
            {percentBars}
            {seeAllCatsBnt}
          </div>
        </Card>
      </div>

      <div className="calculation-control-btns">
        {deleteBtn}
        <button onClick={onSaveCalculation} disabled={(!!calculationStatus)} className="btn btn-default-ok" type="button">SAVE CURRENT CALCULATION</button>
      </div>

      <div className="calculation-display">
        <h3>{templateName}{editedTemp}</h3>
        {categoriesHtml}
      </div>
      {alertModal}
      {alertModalMsg}
      {alertTemplateAlteration}
    </div>
  )
}


const mapState2Props = ({calculation,template})=>({
  calculating: calculation.calculating,
  calculatingCountry: calculation.calculatingCountry,
  calculationStatus: calculation.calculationStatus,
  calculationList: calculation.calculationList,
  userTemplates: template.userTemplates,
});

// TODO - remove
const mapDispatch2Props=(dispatch)=>({
  startGetUserTemplates: (checkUpdate)=>dispatch(startGetUserTemplates(checkUpdate)),
  setCalculatingCountry: (countryData)=>dispatch(setCalculatingCountry(countryData)),
  setCalculating: (template)=>dispatch(setCalculating(template)),
  startSavingCalculation: (calc)=>dispatch(startSavingCalculation(calc)),
  startLoadingCalculations: ()=>dispatch(startLoadingCalculations()),
  startDeletingCalculation: (id)=>dispatch(startDeletingCalculation(id)),
  startLoadingCalculatingTopicData: (template)=>dispatch(startLoadingCalculatingTopicData(template)),
});

export default connect(mapState2Props,mapDispatch2Props)(Calculation);